import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-alertbox',
  templateUrl: './alertbox.component.html',
  styleUrls: ['./alertbox.component.scss']
})
export class AlertboxComponent implements OnInit {
@Input() error;
  constructor() { }

  ngOnInit(): void {
  }

}
